import { Box, Href, Text } from '@factorialco/deprecated-design-system'
import { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import { ContractFlowType } from 'modules/contracts/components/FlowPage'
import Hint from 'modules/contracts/components/FlowPage/FormWrapper/Hint'
import type JobLevelSalaryRange from 'modules/job_catalog/store/models/JobLevelSalaryRange'

import SalaryRangeHint from './_SalaryRangeHint'

interface Props {
  salaryAmountField: Field
  salaryFrequencyField: Field
  isSalarySectionFocused: boolean
  legalEntityCountry: string
  salaryRange?: JobLevelSalaryRange | undefined
  step: number
  type: ContractFlowType
}

const SalaryHint = ({
  salaryAmountField,
  salaryFrequencyField,
  isSalarySectionFocused,
  legalEntityCountry,
  salaryRange,
  step,
  type,
}: Props) => {
  if (salaryRange && isSalarySectionFocused)
    return (
      <SalaryRangeHint
        salaryAmountField={salaryAmountField}
        salaryFrequencyField={salaryFrequencyField}
        salaryRange={salaryRange}
        legalEntityCountry={legalEntityCountry}
      />
    )

  const salaryAmount = salaryAmountField.value
  const salaryFrequency = salaryFrequencyField.value

  const trackSalaryLink = () => {
    track(trackingEvents.employee.contracts.goToSalaryLink, {
      step: step,
      type: type,
    })
  }

  return (
    <Hint color="viridian100" visible={!salaryAmount || !salaryFrequency}>
      {/* TODO obtain correct help center link */}
      <Href
        onClick={() => trackSalaryLink()}
        href={helpCenterUrl('about_contracts_salary')}
        target="_blank"
      >
        <Text.Normal size="100" weight="normal" color="grey1000">
          {i18n.t('contract_versions.flows.fix.steps.role_level_salary.hints.salary')}
          <Text.Normal size="100" weight="normal" color="grey1000" underlined>
            <Box paddingLeft="s2">{i18n.t('contract_versions.flows.fix.hints.know_more')}</Box>
          </Text.Normal>
        </Text.Normal>
      </Href>
    </Hint>
  )
}

export default observer(SalaryHint)
